export const blockIconsDeviceTungsten = (
	<span className='material-symbols-outlined'>tungsten</span>
);
